<template>
  <div class="page-container" v-role="'ped'">
    <!-- Loader -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialogObservacao" max-width="500px">
      <v-card>
        <v-card-title class="headline">Observação</v-card-title>
        <v-card-text>
          <p v-for="(paragrafo, index) in observacaoSelecionada" :key="index"
            :style="{ color: anulado === 1 && index === observacaoSelecionada.length - 1 ? 'red' : 'inherit' }">
            {{ paragrafo }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogObservacao = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Barra de pesquisa -->
    <div class="search-container">
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar por estudante ou instituição destino"
        outlined dense clearable hide-details class="search-bar"></v-text-field>
    </div>

    <!-- Tabela de solicitações -->
    <v-card width="1400px" class="mx-auto">
      <v-data-table :headers="headers" :items="solicitacoesEnviadas" :sort-desc="true" class="elevation-1"
        :search="search">
        <!-- Índice -->
        <template v-slot:item.ord="{ item }">
          <span>{{ solicitacoesEnviadas.indexOf(item) + 1 }}</span>
        </template>

        <!-- Status -->
        <template v-slot:item.status="{ item }">
          <span v-if="parseInt(item.status) === 1" class="status status-aprovada">Aprovado</span>
          <span v-else class="status status-pendente"><v-icon>mdi-progress-clock</v-icon></span>
        </template>

        <!-- Validação IMS -->
        <template v-slot:item.imsValidation="{ item }">
          <span v-if="parseInt(item.imsValidation) === 1 && parseInt(item.anulado) === 0"
            class="status status-aprovada">
            Autorizado
          </span>
          <span v-else-if="parseInt(item.anulado) === 1" class="status status-rejeitado">
            Rejeitado
          </span>
          <span v-else class="status status-pendente">
            Pendente
          </span>
        </template>

        <!-- Action Menu Column -->
        <template v-slot:item.action="{ item }">
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn fab small color="primary" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :disabled="!item.validationNote" @click="visualizarObs(item)">
                <v-icon color="green" small class="mr-2">mdi-note-text</v-icon>
                Visualizar observação
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <!-- Mensagem quando não há dados -->
        <template v-slot:no-data>
          Dados não encontrados!
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      isLoading: false,
      search: '',
      solicitacoesEnviadas: [],
      dialogObservacao: false,
      observacaoSelecionada: [],
      anulado: 0, // Guarda se está anulado ou não
      headers: [
        { text: '#', value: 'ord' },
        { text: 'Nome', value: 'nomeEstudante' },
        { text: 'Matrícula', value: 'idMatricula' },
        { text: 'Curso', value: 'descricao_curso' },
        { text: 'Classe', value: 'classe' },
        { text: 'Destino', value: 'descricao_instituicao_destino' },
        { text: 'Validação (IMS)', value: 'imsValidation' },
        { text: 'Autor Validação (IMS)', value: 'imsValidationAuthor' },
        { text: 'Estado instituição destino', value: 'status' },
        { text: 'Data (transferência)', value: 'data_transferencia' },
        { text: "Ação", value: "action", align: "center" }
      ]
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    async initialize() {
      this.isLoading = true
      try {
        const response = await axios.get('/ListarSolicitacoesTransferiasEnviadas')
        this.solicitacoesEnviadas = response.data
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao efetuar a operação', 'error')
      } finally {
        this.isLoading = false
      }
    },


    visualizarObs(item) {
      if (item.validationNote) {
        this.observacaoSelecionada = item.validationNote.split("\n");
        this.anulado = parseInt(item.anulado);
        this.dialogObservacao = true;
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
}
.search-container {
  width: 40%;
  margin-bottom: 15px;
}
.search-bar {
  width: 100%;
}
/* Estilos para status */
.status {
  font-weight: bold;
}
.status-aprovada {
  color: green;
}
.status-rejeitado {
  color: red;
}
.status-pendente {
  color: #a69605;
}
</style>
